<div (click)="toggle()">
  <ng-content select="[toggle]"></ng-content>
</div>

@if (!collapsed) {
  <ng-content select="[collapsable]"></ng-content>
}
